// extracted by mini-css-extract-plugin
export var root = "C_tN";
export var wrapper = "C_tP";
export var image = "C_tQ d_s d_v d_S";
export var crop = "C_tR";
export var round = "C_tS";
export var fixedHeight = "C_tT";